import { Post } from '../helpers';

const PublishProject = async ({
  projectUuid,
  url,
}: {
  projectUuid: string;
  url: string;
}): Promise<{ uuid: string }> => {
  return Post({
    path: '/v3/admin/events/publish',
    body: { uuid: projectUuid, url },
  });
};

export default PublishProject;
